import axios from "axios";

const API_BASE = (process.env.REACT_APP_API_BASE_URL || "").replace(/\/+$/, "");

export async function obtenerMovtosCliente(cliente, empresa) {
  const resp = await axios.get(`${API_BASE}/api/pagos/movtos-cliente`, {
    params: { cliente, empresa },
  });
  return resp.data;
}

export async function obtenerSiguienteFolioCP(empresa) {
  const resp = await axios.get(`${API_BASE}/api/pagos/siguiente-folio`, {
    params: { empresa },
  });
  return resp.data;
}

export async function aplicarPago(payload) {
  const resp = await axios.post(`${API_BASE}/api/pagos/aplicar`, payload);
  return resp.data;
}

export async function cancelarPago({ folio, empresa, motivo }) {
  const resp = await axios.post(`${API_BASE}/api/pagos/cancelar`, { folio, empresa, motivo });
  return resp.data;
}

export async function obtenerAcuseCancelacion(folio, empresa) {
  const resp = await axios.get(`${API_BASE}/api/pagos/acuse-cancelacion`, {
    params: { folio, empresa },
  });
  return resp.data;
}

export async function obtenerListaPagos(empresa, anio, mes) {
  const resp = await axios.get(`${API_BASE}/api/pagos/lista`, {
    params: { empresa, anio, mes },
  });
  return resp.data;
}

export async function obtenerDetallePago(folio, empresa) {
  const resp = await axios.get(`${API_BASE}/api/pagos/detalle-pago`, {
    params: { folio, empresa },
  });
  return resp.data;
}

export async function obtenerXmlPago(folio, empresa) {
  const resp = await axios.get(`${API_BASE}/api/pagos/xml-pago`, {
    params: { folio, empresa },
    responseType: "text",
  });
  return resp.data;
}

// PDF real del complemento de pago (el mismo que se adjunta en el correo)
export async function obtenerCpPdf(folio, empresa) {
  const resp = await axios.get(`${API_BASE}/api/pagos/cp-pdf`, {
    params: { folio, empresa },
    responseType: "blob",
  });
  return resp.data; // Blob
}

export async function enviarCorreoPago(payload) {
  const resp = await axios.post(`${API_BASE}/api/pagos/enviar-correo`, payload);
  return resp.data;
}
